// src/components/NewCaseWizard/NewCaseReverseUpload.tsx

import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from '../common/Button';
import { Patient } from '../../interfaces/patient';

interface NewCaseReverseUploadProps {
  patient?: Patient;
  onCaseCreated?: () => void;
}

export const NewCaseReverseUpload = ({
  patient,
}: NewCaseReverseUploadProps) => {
  const { t } = useTranslation('Actions');
  const navigate = useNavigate();

  const handleOpenNewCase = () => {
    // If we have a patient prop (from a profile page), pass it in the router state
    if (patient) {
      navigate('/new-case', { state: { contextPatient: patient } });
    } else {
      navigate('/new-case');
    }
  };

  return (
    <div className="w-full flex justify-center items-center">
      <Button onClick={handleOpenNewCase} size="sm">
        <span>+ {t('newCase')}</span>
      </Button>
    </div>
  );
};